/**
 * Fallback break duration in minutes.
 * IMPORTANT: This should be replaced with facility-specific breakConfiguration.breakDurationInMinutes
 * when available. This constant should only be used as a last resort.
 */
const DEFAULT_BREAK_DURATION = 30;

/**
 * Gets the break duration for a facility, with fallback to default.
 *
 * @param facilityBreakConfiguration - The facility's break configuration
 * @returns Break duration in minutes
 */
export function getBreakDuration(
  facilityBreakConfiguration?: {
    breakDurationInMinutes: number;
    // eslint-disable-next-line @typescript-eslint/ban-types
  } | null
): number {
  return facilityBreakConfiguration?.breakDurationInMinutes ?? DEFAULT_BREAK_DURATION;
}
